module.exports = __webpack_public_path__ + "components/rewards/no-ads/static/logo-9fa125e01e76499656aac6720da0af59.webp";